import React, {Component, Fragment} from 'react';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';


import Dropdown from 'Components/Dropdown';

import { SingleDatePicker, DateRangePicker } from 'react-dates';
import Input from 'Components/Input/index';
import { isAdaniWilmar } from 'Utils/';
import { IS_RIL_RETAIL, PRODUCT_TYPE, DEEPAK_PHENOLICS, GREEN_PLY, CENTURY_PLY } from 'Constants/commonConstants';
import { getCompanyName, getUser } from 'Utils/storage';
import Checkbox from 'Components/Checkbox/index';
import InfoCard from './InfoCard';
import { Spacer } from 'Components/Common/Spacer/index';
import { isDesmet } from 'Utils/index';


class VehicleDetails extends Component {
    constructor(props) {
        super(props);
        this.trip = props.trip;
        this.state = {
            activeView: 1,
            trip: this.trip,
            vehicleCopy: []
        }
        this.viewMode = props.viewMode;
    }
    setVehicleType = (vehicleType)=> {
        if(this.viewMode) {
            return;
        }
        // this.trip.setVehicleType(vehicleType.value, vehicleType.name);
        // this.setState({
        //     trip: this.trip
        // });
        const { trip } = this.state;
        const { cargoInfo } = this.props;
        trip.vehicleType = vehicleType.value;
        trip.vehicleTypeName = vehicleType.name;
        trip.carryingCapacity = DEEPAK_PHENOLICS.includes(getUser().id) ? ((vehicleType.carrying_capacity * (cargoInfo.productDensity ? (cargoInfo.productDensity > 1 ? Math.floor(cargoInfo.productDensity) : cargoInfo.productDensity) : 1)) || 0).toFixed(2) : vehicleType.carrying_capacity;
        trip.requiredVehicleCapacity = vehicleType.vehicle_capacity_MT;
        trip.vehicleCapacity = vehicleType.vehicle_capacity;
        this.trip.setVehicleType(vehicleType.value, vehicleType.name);
        this.trip.setRequiredVehicleCapacity(vehicleType.vehicle_capacity_MT);
        this.trip.setVehicleCapacity(vehicleType.vehicle_capacity);
        this.trip.setSAPVehicleId(vehicleType.sap_mapping_id);
        this.setState({ trip });
        this.props.onChange()
    }
    setVehicleBodyType = (vehicleBodyType)=> {
        if(this.viewMode) {
            return;
        }
        // this.trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
        // this.setState({
        //     trip: this.trip
        // });

        const { trip } = this.state;
        trip.vehicleBodyType = vehicleBodyType.value;
        trip.vehicleBodyTypeName = vehicleBodyType.name;
        this.trip.setVehicleBodyType(vehicleBodyType.value, vehicleBodyType.name);
        this.setState({ trip });

        this.props.onChange()
    }
    setProductCategory = (productCategory) => {
        if (this.viewMode) {
            return;
        }
        this.trip.setProductCategoryType(productCategory.value, productCategory.name, productCategory.density);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }
    onChangeRemarks = (e)=> {
        const { trip } = this.state;
        trip.remarks = e.target.value;
        this.trip.setRemarks(e.target.value);
        this.setState({ trip });
        this.props.onChange()
    }

    onAddNoOfContainers = (e) => {
        this.trip.setNoOfContainers(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    onAddNoOfTrucks = (e) => {
        this.trip.setNumberOfVehicle(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    onAddTruckCapacity = (e) => {
        this.trip.setTruckCapacity(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    setDphHike = (e) => {
     this.trip.dphHikeIndicator= e.target.checked;
    this.trip.setDphHikePrice(e.target.checked);
      this.setState({
          trip : this.trip
      })
      this.props.onChange()
    }

    setVehicleSpec = (data, id) => {
        this.trip.setVehicleSpecification(data, id);
        this.setState({
            trip : this.trip
        })
        this.props.onChange()
    }

    onAddFuleVariation = (e) => {
        this.trip.increaseDecreasePrice = e.target.value;
         this.trip.setFuleVariation(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    onAddMileage= (e) => {
        this.trip.mileage = e.target.value;
        this.trip.setMileage(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    onAddMinimumGuarantee= (e) => {
        this.trip.minimumGuarantee = e.target.value;
        this.trip.setMinimumGuarantee(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    onRequiredVehicleCapacity= (e) => {
        this.trip.setRequiredVehicleCapacity(e.target.value);
        this.setState({
            trip: this.trip
        });
        this.props.onChange()
    }

    sortVehicleTypes = () => {
        const {vehicleBodyTypes} = this.props;
        let types = [];
        (vehicleBodyTypes || []).map((body) => {
            let duplicates = (types || []).filter(obj => obj.value === body.dph_type)
            if(duplicates.length === 0 && body.dph_type > -1){
                types.push({value: body.dph_type, label: body.dph_type_name})
            }
        })
        this.setState({vehicleCopy: types})
    }

    render() {
        const { 
            vehicleTypes,
            vehicleBodyTypes,
            productCategories,
            disablePlacementTime ,
            shouldShowVehicleTypes,
            submitted,
            rfqServiceType,
            cargoInfo,
            rfqDetails,
            trip
        } = this.props;
        const companyName = getCompanyName();
        const companyType = (companyName && companyName.includes(IS_RIL_RETAIL));
        const dropdownItems = ['id', 'name'];
        const user = getUser();
        const { vehicleCopy } = this.state;
        const isVehicleBody = ["20 FT Trailer", "40 FT Trailer"].includes(this.trip.vehicleTypeName) 
        if(DEEPAK_PHENOLICS.includes(user.id) && vehicleCopy.length === 0){
            this.sortVehicleTypes();
        }
        return (
            <div className="pr">
                <div className={'flex'}>
                    {shouldShowVehicleTypes && <div className={DEEPAK_PHENOLICS.includes(user.id) ? "mb-30 col-2" : "mb-30 col-1"}>
                        <div className="header-medium-color fBold fs-16 mb-5">
                            Select Vehicle <sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Dropdown 
                        onSelect={this.setVehicleType}
                        items={vehicleTypes} selectedItem={vehicleTypes.find((vehicleType)=> {
                            return vehicleType.value === this.trip.vehicleType
                        })} 
                        label="Select Vehicle Type" 
                        displayKey="name"
                        searchEnabled={true}
                        searchPlaceholder={'Search Vehicle Types'}
                        hasError ={submitted && !vehicleTypes.find((vehicleType)=> {
                            return vehicleType.value === this.trip.vehicleType
                        })}
                        />
                    </div>}
                    {user.isShowDphDetails && 
                    <div className="mt-40 ml-20 col-2">
                    <div className="header-medium-color fBold fs-16 mb-5">
                        {this.trip.carryingCapacity} MT
                    </div>
                    </div>}
                    {user.showPinCodeDetails && <div className="mb-30 col-4 ml-20">
                        <div className="header-medium-color fBold fs-16 mb-5">
                                Truck Capacity<sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Input 
                            value={this.trip.truckCapacity}
                            onChange={this.onAddTruckCapacity}
                            name="truckCapacity"
                            placeholder="Eg. 30MT"
                        />
                        {submitted && !this.trip.truckCapacity &&  <div className="error-color fs-14 fSemibold op-7 mt-10">Enter Truck Capacity</div>}
                    </div>}
                </div>
                {shouldShowVehicleTypes && 
                <div className={'flex flex-between'}>
                    {(DEEPAK_PHENOLICS.includes(user.id) ? isVehicleBody : true) &&
                     <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                            {`Select ${rfqServiceType === 4 ? 'Vehicle Body' : 'Vehicle Body'}  Type`} <sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Dropdown 
                        items={vehicleBodyTypes} selectedItem={vehicleBodyTypes.find((vehicleBodyType)=> {
                            return vehicleBodyType.value === this.trip.vehicleBodyType
                        })}
                        onSelect={this.setVehicleBodyType}
                        label="Select Vehicle Body Type" 
                        displayKey="name"
                        searchEnabled={true}
                        searchPlaceholder={'Search Body Types'}
                        hasError ={submitted && !vehicleBodyTypes.find((vehicleBodyType)=> {
                            return vehicleBodyType.value === this.trip.vehicleBodyType
                        })}
                        />
                    </div>}
                    {rfqServiceType === 4 && <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                            Select Number Of Containers<sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Input 
                            type='number'
                            value={this.trip.noOfContainers}
                            onChange={this.onAddNoOfContainers}
                            name="noOfContainers"
                            placeholder="No. Of Containers"
                        />
                    </div>}
                    { user.isShowDphDetails && !isVehicleBody &&
                    <Fragment>
                        {(vehicleCopy || []).map((body) => {
                            return (
                                <Fragment>
                                    <div className="mr-10 mb-30">
                                    <div className='wt-100p tCenter borderLight'>
                                        <div className='header-medium-color mb-10 fBold'>{body.label}</div>
                                        {(vehicleBodyTypes || []).map((data) => {
                                           if(data.dph_type === body.value){
                                           return(
                                                <div className="flex mb-10 fs-12 tLeft">
                                                <Checkbox label={data.name}  className="mr-10" checked={(this.trip.vehicleSpecification.length > 0) ? (this.trip.vehicleSpecification.filter(obj => obj.value === data.value).length > 0) : false}  onCheck={() => this.setVehicleSpec(data, data.value)}/>
                                                </div>
                                            )}
                                        })
                                    }    
                                </div>  
                                </div>
                                </Fragment>
                            )
                        })}
                    </Fragment>}

                    {rfqServiceType === 4 && <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                            Select Number Of Containers<sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Input 
                            type='number'
                            value={this.trip.noOfContainers}
                            onChange={this.onAddNoOfContainers}
                            name="noOfContainers"
                            placeholder="No. Of Containers"
                        />
                    </div>}
                    {(isAdaniWilmar() || [...CENTURY_PLY, ...GREEN_PLY].includes(user.companyId)) && <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                        {`Vehicle Capacity${isAdaniWilmar() ? '/Scale Capacity (in MT)' : ''}`}{(isAdaniWilmar() || CENTURY_PLY.includes(user.companyId)) && <sup className="danger-color ml-2 pr t-4">*</sup>}
                        </div>
                        <Input 
                            type='number'
                            value={((isAdaniWilmar() || CENTURY_PLY.includes(user.companyId)) ? this.trip.vehicleCapacity : this.trip.requiredVehicleCapacity) || ''}
                            onChange={this.onRequiredVehicleCapacity}
                            name={(isAdaniWilmar() || CENTURY_PLY.includes(user.companyId)) ? "vehicleCapacity" : "requiredVehicleCapacity"}
                            placeholder="Vehicle Capacity"
                            readOnly={[...CENTURY_PLY, ...GREEN_PLY].includes(user.companyId) || isAdaniWilmar()}
                            hasError={submitted && (isAdaniWilmar() || CENTURY_PLY.includes(user.companyId)) && !this.trip.vehicleCapacity}
                        />
                        {submitted && (!isAdaniWilmar() && !CENTURY_PLY.includes(user.companyId)) && !this.trip.minimumGuarantee &&  <div className="error-color fs-14 fSemibold op-7 mt-10">Vehicle Capacity</div>}
                    </div>}
                </div>
                }
                

                {isDesmet() && <Fragment>
                    <InfoCard
                        recommended_vehicle={trip.recommended_vehicle}
                        tentative_pickup_date={trip.tentative_pickup_date}
                    />
                    <Spacer spacing={"10px"} />
                </Fragment>}

                    {user.isShowDphDetails && 
                    <div className="mb-30">
                        
                        <div className="header-medium-color fBold fs-16 mb-5">
                        Minimum Guarantee(MT)<sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Input 
                            type='number'
                            value={this.trip.minimumGuarantee}
                            onChange={this.onAddMinimumGuarantee}
                            name="minimumGuarantee"
                            placeholder="Minimum Guarantee(MT)"
                        />
                        {submitted && !this.trip.minimumGuarantee &&  <div className="error-color fs-14 fSemibold op-7 mt-10">Minimum Guarantee(MT)</div>}
                    </div>}
                    {(disablePlacementTime && !CENTURY_PLY.includes(user.companyId) && ((rfqDetails || {}).ftlContractType !== 2)) && <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                        Select Placement Time
                    </div>
                    <div className="flex pb-20">
                        <SingleDatePicker
                            noBorder={true}
                            displayFormat={"DD MMM YYYY"}
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel={true}
                            placeholder={"Placement Date"}
                            numberOfMonths={2}
                            date={this.trip.placementTime ? Moment(this.trip.placementTime) : ''} 
                            onDateChange={(placementDate) =>{
                                if(this.viewMode) {
                                    return;
                                }
                                const date = placementDate.format('YYYY-MM-DD') + ' ' + Moment(this.trip.placementTime).format('HH:mm')
                                this.trip.setPlacementTime(new Date(date).getTime());
                                this.setState({ trip: this.trip });
                                this.props.onChange()
                            }}
                            focused={this.state.focusedStart} 
                            onFocusChange={({ focused }) => this.setState({ focusedStart: focused })} 
                        />
                        <TimePicker
                            placeholder={"Placement Time"}
                            showSecond={false}
                            value={this.trip.placementTime ? Moment(this.trip.placementTime) : ''}
                            className="ht-40 wt-150 border-status-bar br-5"
                            onChange={(placementTime) =>{
                                if(this.viewMode) {
                                    return;
                                }
                                const date = Moment(this.trip.placementTime).format('YYYY-MM-DD') + ' ' + placementTime.format('HH:mm')
                                this.trip.setPlacementTime(new Date(date).getTime());
                                this.setState({ trip: this.trip });
                                this.props.onChange()
                            }}
                            format={'h:mm a'}
                            use12Hours
                            inputReadOnly
                        />
                    </div>
                </div>}
                {shouldShowVehicleTypes && companyType && <div className="mb-30">
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Select Product Type<sup className="danger-color ml-2 pr t-4">*</sup>
                    </div>
                    <Dropdown 
                    items={productCategories.filter(function(o1){
                            return PRODUCT_TYPE.some(function(o2){ return o1.value === o2.value; });
                        }).map(function(o){
                            return dropdownItems.reduce(function(newo, name){
                                newo[name] = o[name];
                                return newo;
                            }, {});
                        })
                    } 
                    selectedItem={productCategories.find((category)=> {
                        return category.value === this.trip.productCategoryType
                    })}
                    onSelect={this.setProductCategory}
                    label="Select Product Type" 
                    displayKey="name"
                    searchEnabled={true}
                    searchPlaceholder={'Search Product Type'}
                    hasError ={submitted && !productCategories.find((category)=> {
                        return category.value === this.trip.productCategoryType
                    })}
                    />
                </div>}

                <div className="">
                    <div className="header-medium-color fBold fs-16 mb-5">
                        Remarks
                    </div>
                    <Input 
                        value={this.trip.remarks}
                        onChange={this.onChangeRemarks}
                        name="remarks"
                        placeholder="Please Enter Remarks"
                    />
                </div>
                {user.isShowDphDetails && <div className="">
                <div className="header-medium-color fBold fs-16 mb-5 mt-10">
                         DPH Hike 
                    </div>
                <div className="flex mb-35">
                        {/* <Checkbox label="DPH Hike"  className="mr-30" checked={this.trip.dphHikeIndicator === 1}  onCheck={this.setDphHike.bind(this, 1)}/> */}
                        <input type="checkbox" checked={this.trip.dphHikeIndicator} onChange={this.setDphHike.bind(this)}/>
                     </div>
                     { this.trip.dphHikeIndicator && <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                        Increase/Decrease Rupee <sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Input 
                            type='number'
                            value={this.trip.increaseDecreasePrice}
                            onChange={this.onAddFuleVariation}
                            name="increaseDecreasePrice"
                            placeholder="Increase/Decrease Rupee"
                        />
                        {submitted && !this.trip.increaseDecreasePrice &&  <div className="error-color fs-14 fSemibold op-7 mt-10">Enter Increa/Decrease Rupee</div>}
                    </div>}
                    { this.trip.dphHikeIndicator && <div className="mb-30">
                        <div className="header-medium-color fBold fs-16 mb-5">
                        Mileage<sup className="danger-color ml-2 pr t-4">*</sup>
                        </div>
                        <Input 
                            type='number'
                            value={this.trip.mileage}
                            onChange={this.onAddMileage}
                            name="mileage"
                            placeholder="Enter Mileage"
                        />
                        {submitted && !this.trip.mileage &&  <div className="error-color fs-14 fSemibold op-7 mt-10">Enter Mileage</div>}
                    </div>}
                     </div>}
                {!shouldShowVehicleTypes && disablePlacementTime &&  <div className="pa center caption-color fSemibold fs-16 mt-20 ml-20">Nothing To Enter</div>}
            </div>
        )
    }
}

export default VehicleDetails;
